import { PracticePatient } from "@physiofit-digital/physiofit_types";
import { doc, onSnapshot } from "firebase/firestore";
import { useEffect, useState } from "react";
import { getPracticePatientId } from "../../../core/store/currentFormSlice";
import { useMainStore } from "../../../core/store/mainStore";
import { db } from "../../../firebaseConfig";
import { useExpireWebAppSession } from "../../navigation/utils/webAppSession";

export const usePracticePatientConnect = () => {
  const practicePatientId = useMainStore(getPracticePatientId);
  const setPracticePatient = useMainStore((state) => state.setPracticePatient);
  const expire = useExpireWebAppSession();
  const [practicePatientData, setPracticePatientData] =
    useState<PracticePatient>();
  useEffect(() => {
    if (!practicePatientId) {
      setPracticePatientData(undefined);
      setPracticePatient(undefined);
      return;
    }
    const sub = onSnapshot(
      doc(db, "practicePatients/" + practicePatientId),
      (doc) => {
        if (doc.exists()) {
          const data = doc.data() as PracticePatient;
          setPracticePatientData(data);
          setPracticePatient(data);
        } else {
          setPracticePatientData(undefined);
          setPracticePatient(undefined);
        }
      },
      (error) => {
        // The rules authorise this read through a get() on the same document
        // (verifiedPhone === phone.phoneNumber). A missing or unlinked document, or a session past
        // its 60-minute limit, therefore arrives as permission-denied rather than exists() === false —
        // without this callback the listener died silently and left stale patient data on screen.
        console.error("Practice patient listener failed:", error);
        setPracticePatientData(undefined);
        setPracticePatient(undefined);
        if (error.code === "permission-denied") expire();
      }
    );
    return () => sub();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [practicePatientId]);
  return practicePatientData;
};
